var _defs, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaymentClearpay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Clearpay_Badge_BlackonMint",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 28.899,
    viewBox: "0 0 85 28.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cp-cls-1 {\n        fill: #b2fce4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clearpay_Badge_Bg",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    className: "cp-cls-1",
    d: "M195.851,173h-56.1A14.449,14.449,0,0,1,125.3,158.549h0A14.449,14.449,0,0,1,139.749,144.1h56.1A14.449,14.449,0,0,1,210.3,158.549h0A14.449,14.449,0,0,1,195.851,173Z",
    transform: "translate(-125.3 -144.1)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Clearpay_Logo_Black",
    transform: "translate(11.352 8.654)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(24.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(18.518 2.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M1158.631,360.2l-4.258,8.784h-1.765l1.591-3.281-2.5-5.5h1.811l1.607,3.686,1.754-3.686Z",
    transform: "translate(-1151.7 -360.2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(0 2.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M885.941,361.234a1.7,1.7,0,1,0-1.7,1.785,1.73,1.73,0,0,0,1.7-1.785M881,366.9v-8.784h1.533v.808A2.479,2.479,0,0,1,884.5,358a3.07,3.07,0,0,1,3.008,3.219,3.1,3.1,0,0,1-3.045,3.229,2.413,2.413,0,0,1-1.885-.835v3.282H881Z",
    transform: "translate(-876.695 -358)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M1020.767,361.329a1.7,1.7,0,1,0-1.7,1.785,1.7,1.7,0,0,0,1.7-1.785m.011,3.119v-.808a2.5,2.5,0,0,1-1.969.908,3.044,3.044,0,0,1-3.008-3.218,3.1,3.1,0,0,1,3.045-3.229,2.5,2.5,0,0,1,1.932.9v-.788h1.533v6.238Z",
    transform: "translate(-1004.417 -358.095)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M800.538,358.725a1.632,1.632,0,0,1,2.022-.583v1.591a1.97,1.97,0,0,0-1.108-.284,1.1,1.1,0,0,0-.866,1.208v3.7H799v-6.238h1.533v.609Z",
    transform: "translate(-799 -358)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M1291.273,311.273l-1.817-1.04-1.843-1.055a1.83,1.83,0,0,0-2.741,1.586V311a.357.357,0,0,0,.183.315l.857.488a.354.354,0,0,0,.53-.31v-.562a.362.362,0,0,1,.541-.315l1.681.966,1.675.961a.36.36,0,0,1,0,.625l-1.675.961-1.681.966a.362.362,0,0,1-.541-.315V314.5a1.828,1.828,0,0,0-2.741-1.586l-1.842,1.055-1.816,1.04a1.834,1.834,0,0,0,0,3.177l1.816,1.039,1.842,1.055a1.83,1.83,0,0,0,2.741-1.586v-.236a.357.357,0,0,0-.184-.315l-.856-.488a.355.355,0,0,0-.53.31v.562a.362.362,0,0,1-.541.315l-1.68-.966-1.675-.961a.36.36,0,0,1,0-.625l1.675-.961,1.68-.966a.362.362,0,0,1,.541.315v.278a1.828,1.828,0,0,0,2.741,1.586l1.843-1.055,1.817-1.04A1.833,1.833,0,0,0,1291.273,311.273Z",
    transform: "translate(-1253.917 -308.933)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(0 0.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M347.9,362.027a3.252,3.252,0,0,1-6.4-.8A3.181,3.181,0,0,1,344.755,358a3.142,3.142,0,0,1,3.129,2.394h-1.622a1.7,1.7,0,0,0-1.5-.935,1.771,1.771,0,0,0,0,3.539,1.635,1.635,0,0,0,1.507-.971Z",
    transform: "translate(-341.5 -355.548)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M477.2,320.1v-8.8h1.57v8.8Z",
    transform: "translate(-470.075 -311.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M522.538,361.739a1.546,1.546,0,0,0,1.606,1.444,1.647,1.647,0,0,0,1.47-.809h1.607a3.254,3.254,0,0,1-6.321-1.034,3.151,3.151,0,0,1,3.239-3.239,3.118,3.118,0,0,1,3.2,3.239,1.979,1.979,0,0,1-.037.4Zm3.129-.976a1.492,1.492,0,0,0-1.544-1.3,1.542,1.542,0,0,0-1.57,1.3Z",
    transform: "translate(-511.48 -355.643)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M660.672,364.348v-.808a2.49,2.49,0,0,1-1.969.908,3.044,3.044,0,0,1-3-3.219A3.1,3.1,0,0,1,658.74,358a2.477,2.477,0,0,1,1.932.9v-.788h1.533v6.232h-1.533Zm-.016-3.119a1.7,1.7,0,1,0-1.7,1.785A1.707,1.707,0,0,0,660.657,361.229Z",
    transform: "translate(-639.203 -355.548)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaymentClearpay);
export default __webpack_public_path__ + "static/media/logo-payment-clearpay.d49ae69b.svg";
export { ForwardRef as ReactComponent };